module.exports = __webpack_public_path__ + "media/svg/bd-cba89210.svg";